import CurrentCasePage from "./CurrentCasePage";

export default CurrentCasePage;
